import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import { AddLinkButton, SectionContainer, SectionTitle } from '../Shared';
import { TestIds } from './constants';
import { AnnotationArea } from './AnnotationArea';

/** more options section id and testID */
export var SECTION_ID = 'more-options-section';
export var SECTION_TEST_ID = 'more-options-section-test-id';
export var MoreOptionsSection = function MoreOptionsSection() {
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAnnotationAreaOpen = _useState2[0],
    setIsAnnotationAreaOpen = _useState2[1];
  useEffect(function () {
    if (values.annotation) {
      setIsAnnotationAreaOpen(true);
    }
  }, [values.annotation]);
  var handleAddAnnotationClick = function handleAddAnnotationClick() {
    setIsAnnotationAreaOpen(true);
  };
  var handleCloseAnnotationArea = function handleCloseAnnotationArea() {
    setIsAnnotationAreaOpen(false);
  };
  return /*#__PURE__*/React.createElement(SectionContainer, {
    role: "group",
    "aria-labelledby": "annotation-label",
    id: SECTION_ID,
    "data-test": SECTION_TEST_ID
  }, /*#__PURE__*/React.createElement(SectionTitle, {
    id: "annotation-label"
  }, "More options"), isAnnotationAreaOpen ? /*#__PURE__*/React.createElement(AnnotationArea, {
    handleClose: handleCloseAnnotationArea
  }) : /*#__PURE__*/React.createElement(AddLinkButton, {
    "data-test": TestIds.ADD_ANNOTATION_LINK,
    onClick: handleAddAnnotationClick,
    label: "Add Annotation"
  }));
};